import React, { useState, useEffect } from "react";
import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import Hero from "../components/Hero";
import WhyChoose from "../components/WhyChoose";
import LifeAtSchool from "../components/LifeAtSchool";
import News from "../components/News";
import Footer from "../components/Footer";
import HomeAbout from "../components/HomeAbout";
import { FaTimes } from "react-icons/fa";
import HomeVirtualTour from "./HomeVirtualTour";
import popupImage from "../assets/popup.jpeg";

const Home = () => {
  const [open, setOpen] = useState(false);
  const [popup, setPopup] = useState(false);

  const [notices, setNotices] = useState([]);

  useEffect(() => {
    fetch(" https://node.ilakshyaerp.in/api/notices")
      .then((res) => res.json())
      .then((data) => setNotices(data));

    const alreadyShown =
      sessionStorage.getItem("homePopupShown");

    if (!alreadyShown) {
      setPopup(true);

      sessionStorage.setItem(
        "homePopupShown",
        "yes"
      );
    }
  }, []);

  return (
    <>
      {/* WELCOME POPUP */}

      {popup && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(0,0,0,0.65)",
            zIndex: 99999,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            padding: "15px",
          }}
        >
          <div
            style={{
              width: "100%",
              maxWidth: "700px",
              background: "#fff",
              borderRadius: "18px",
              overflow: "hidden",
              position: "relative",
              boxShadow: "0 20px 60px rgba(0,0,0,0.25)",
            }}
          >
            {/* Close Button */}
            <button
              onClick={() => setPopup(false)}
              style={{
                position: "absolute",
                top: "12px",
                right: "12px",
                border: "none",
                background: "rgba(255,255,255,0.9)",
                width: "40px",
                height: "40px",
                borderRadius: "50%",
                cursor: "pointer",
                fontSize: "16px",
                color: "#1f3c6d",
                zIndex: 10,
              }}
            >
              <FaTimes />
            </button>

            {/* Welcome Image */}
            <img
              src={popupImage}
              alt="Welcome"
              style={{
                width: "100%",
                height: "auto",
                display: "block",
                objectFit: "cover",
              }}
            />

            {/* Button */}
            <div
              style={{
                padding: "20px",
                textAlign: "center",
              }}
            >
              <button
                onClick={() => {
                  setPopup(false);
                  window.location.href = "/about";
                }}
                style={{
                  background: "#1f3c6d",
                  color: "#fff",
                  border: "none",
                  padding: "12px 28px",
                  borderRadius: "8px",
                  cursor: "pointer",
                  fontSize: "16px",
                  fontWeight: "600",
                  width: "100%",
                  maxWidth: "320px",
                }}
              >
                Click Here to Know About Our School
              </button>
            </div>
          </div>
        </div>
      )}

      <Header toggleSidebar={() => setOpen(true)} />

      <div className="announcement">
        <div className="announcement-label">
          📢 ANNOUNCEMENT
        </div>

        <div className="announcement-track">
          <div className="announcement-content">
            {notices.map((n) => (
              <span
                key={n.id}
                onClick={() =>
                  (window.location.href = `/notices/${n.id}`)
                }
              >
                {n.title}
              </span>
            ))}
          </div>
        </div>
      </div>

      <Sidebar
        isOpen={open}
        close={() => setOpen(false)}
      />

      <Hero />

      <div className="container">
        <WhyChoose />
        <HomeAbout />
        <LifeAtSchool />
        <HomeVirtualTour />
        <News />
      </div>

      <Footer />
    </>
  );
};

export default Home;